<template>
  <div>
    <b-row
      class="content-header white-background v-sticky-sidebar-container service_request_task"
      style="border-radius: 6px;"
    >
      <b-col
        class="content-header-right d-md-block"
        style="position: relative;"
        md="12"
        cols="12"
      >
        <b-card
          no-body
          class="mb-0"
        >
          <div class="urn-form-wrapper m-4">
            <div class="pm-header-top floatCss d-flex justify-content-between">
              <div class="pm-logo-left d-flex">
                <div class="pm-logo">
                  <img
                    :src="logoSrc"
                    style="width: 162px; height: auto;"
                  >
                </div>
                <div class="pm-logo-text">
                  <h3>NIRVANA PRESTIGE PTE. LTD.<span>(UEN NO: 201602195C)</span></h3>
                  <h4>AS THE AUTHORISED agent OF THIAN LENG CHONG TOH TONG</h4>
                </div>
              </div>
            </div>
            <b-row>
              <b-col
                cols="5"
                md="5"
                lg="5"
              >
                <div class="cm-header-info">
                  <p>Address: 472 Changi Road Singapore 419890</p>
                </div>
              </b-col>
              <b-col
                cols="7"
                md="7"
                lg="7"
              >
                <div class="cm-header-info-right">
                  <div class="cm-header-info">
                    <p>Tel: +65 68909719</p>
                  </div>
                  <div class="cm-header-info">
                    <p>Website: Thianleng.sg</p>
                  </div>
                </div>
              </b-col>
            </b-row>
            <div class="urn-repository-order_section">
              <div class="b-form-section-title my-2 margin-top-bottom-0">
                <h3>redemption of imported urn form 领取特定骨瓮声明</h3>
              </div>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label-class="label-width-340"
                    label-cols="12"
                    label-cols-md="4"
                    label="REDEMPTION OF IMPORTED URN (NICHE LOT)*:"
                    label-for="input-default"
                    class="align-items-center"
                  >
                    <div
                      class="empty-input__text bg-white"
                    >
                      <p>
                        {{ nicheLot || '-' }}
                      </p>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <b-form-group
                    label-cols="12"
                    label-cols-md="1"
                    label-cols-lg="1"
                    label="I*,"
                    label-for="input-default"
                    class="align-items-center"
                  >
                    <div
                      v-if="currentCustomerNameType == 'input'"
                      class="empty-input__text bg-white"
                    >
                      <p>
                        {{ customerName || '-' }}
                      </p>
                    </div>
                    <div
                      v-else
                      :class="{ 'signed': customerNameImage }"
                      style="border-bottom: 1px solid #000"
                    >
                      <b-img
                        v-if="customerNameImage"
                        :src="customerNameImage"
                        class="w-100 signature-image"
                        alt="sign"
                      />
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group
                    label-class="label-width-340"
                    label-cols="12"
                    label-cols-md="5"
                    label="Purchaser/authorized representative (NRIC:)* "
                    label-for="input-default"
                    class="align-items-center"
                  >
                    <div
                      class="empty-input__text bg-white"
                    >
                      <p>
                        {{ customerNRIC || '-' }}
                      </p>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <b-form-group
                    label-cols="12"
                    label-cols-md="1"
                    label-cols-lg="1"
                    label="I,"
                    label-for="input-default"
                    class="align-items-center"
                  >
                    <div
                      v-if="currentKinNameType == 'input'"
                      class="empty-input__text bg-white"
                    >
                      <p>
                        {{ kinName || '-' }}
                      </p>
                    </div>
                    <div
                      v-else
                      :class="{ 'signed': kinNameImage }"
                      style="border-bottom: 1px solid #000"
                    >
                      <b-img
                        v-if="kinNameImage"
                        :src="kinNameImage"
                        class="w-100 signature-image"
                        alt="sign"
                      />
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group
                    label-class="label-width-180"
                    label-cols="12"
                    label-cols-md="3"
                    label-cols-lg="3"
                    label="Next of Kin (NRIC:)"
                    label-for="input-default"
                    class="align-items-center"
                  >
                    <div
                      class="empty-input__text bg-white"
                    >
                      <p>
                        {{ kinNRIC || '-' }}
                      </p>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <b-form-group
                    label-class="label-width-320"
                    label-cols="12"
                    label-cols-md="6"
                    label="do hereby acknowledge retrieval of*"
                    label-for="input-default"
                    class="align-items-center"
                  >
                    <div
                      class="empty-input__text bg-white"
                    >
                      <p>
                        {{ numberOfUnit || '-' }}
                      </p>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="7">
                  <b-form-group
                    label-class="label-width-320"
                    label-cols="12"
                    label-cols-md="5"
                    label-cols-lg="5"
                    label="unit of the imported Urn, of the File No.*"
                    label-for="input-default"
                    class="align-items-center"
                  >
                    <div
                      class="empty-input__text bg-white"
                    >
                      <p>
                        {{ fileNo || '-' }}
                      </p>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label-class="label-width-80"
                    label-cols="12"
                    label-cols-md="2"
                    label-cols-lg="2"
                    label="Urn File No."
                    label-for="input-default"
                    class="align-items-center"
                  >
                    <div
                      class="empty-input__text bg-white"
                    >
                      <p>
                        {{ urnFileNo || '-' }}
                      </p>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label-class="label-width-80"
                    label-cols="12"
                    label-cols-md="4"
                    label-cols-lg="4"
                    label="Related File Number"
                    label-for="input-default"
                    class="align-items-center"
                  >
                    <div
                      class="empty-input__text bg-white"
                    >
                      <p>
                        {{ relatedFileNo || '-' }}
                      </p>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="d-form-warning-text-block">
                <p class="d-form-warning-text">
                  as per below on:
                </p>
                <p class="d-form-warning-text">
                  本人乃新加玻天灵总道堂福位购买者 / 购买者之委托人（本人身份证号，文件号码，购买证书编号如上述）现领取如数骨瓮（骨瓮类别与数量如下表纪录
                </p>
              </div>
              <div class="mt-5 margin-top-1">
                <b-table-simple
                  bordered
                  responsive
                >
                  <b-tbody>
                    <b-tr>
                      <b-td
                        colspan="5"
                        class="text-center"
                      >
                        <span>Urn Retrieval Record (Please note the accuracy in the relevant Urn and Quantity)</span>
                        <br>
                        <span>领取骨瓮记载 （请选填类别与数量</span>
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <td
                        :rowspan="splitQuantity ? 2 : 1"
                        width="40%"
                      >
                        Type of Urn
                      </td>
                      <td :rowspan="splitQuantity ? 2 : 1">
                        Urn Code
                      </td>
                      <td :rowspan="splitQuantity ? 2 : 1">
                        Item File No.
                      </td>
                      <td
                        :colspan="splitQuantity ? 2 : 1"
                        class="text-center"
                      >
                        Quantity
                      </td>
                    </b-tr>
                    <b-tr v-if="splitQuantity">
                      <td class="text-center">
                        NMG
                      </td>
                      <td class="text-center">
                        MPL
                      </td>
                    </b-tr>
                    <b-tr
                      v-for="(item, index) in inventoryItems"
                      :key="index"
                    >
                      <b-td>
                        <span>{{ item.name }}</span>
                      </b-td>
                      <b-td>
                        {{ item.sku }}
                      </b-td>
                      <b-td>
                        {{ item.fileNo }}
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ item.quantity[0] > 0 ? item.quantity[0] : '' }}
                      </b-td>
                      <b-td
                        v-if="splitQuantity"
                        class="text-center value-filled"
                      >
                        {{ (item.quantity[1] != undefined && item.quantity[1] > 0) ? item.quantity[1] : '' }}
                      </b-td>
                    </b-tr>
                    <!-- <b-tr>
                      <b-td>
                        <b-form-checkbox
                          v-model="dgcwbs"
                          value="dgcwbs"
                          style="pointer-events: none;"
                          class="form-custom-input-checkbox"
                        />
                      </b-td>
                      <b-td>
                        <span>Deep Green Crystal with Buddhist Sutra</span>
                        <br>
                        <span>心若彼岸 （深青琉璃经文罐</span>
                      </b-td>
                      <b-td>
                        URN0-CRST-DPGN-1203
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ dgcwbsNmg > 0 ? dgcwbsNmg : '' }}
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ dgcwbsMpl > 0 ? dgcwbsMpl : '' }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox
                          v-model="lgcwbs"
                          value="lgcwbs"
                          style="pointer-events: none;"
                          class="form-custom-input-checkbox"
                        />
                      </b-td>
                      <b-td>
                        <span>Light Green Crystal with Buddhist Sutra</span>
                        <br>
                        <span>心若彼岸 （浅青琉璃经文罐</span>
                      </b-td>
                      <b-td>
                        URN0-CRST-LTGN-1203
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ lgcwbsNmg > 0 ? lgcwbsNmg : '' }}
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ lgcwbsMpl > 0 ? lgcwbsMpl : '' }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox
                          v-model="lcwbs"
                          value="lcwbs"
                          style="pointer-events: none;"
                          class="form-custom-input-checkbox"
                        />
                      </b-td>
                      <b-td>
                        <span>Lavender Crystal with Buddhist Sutra</span>
                        <br>
                        <span>紫罗兰琉璃经文罐</span>
                      </b-td>
                      <b-td>
                        URN0-LAVENDER-CRST-LIULI
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ lcwbsNmg > 0 ? lcwbsNmg : '' }}
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ lcwbsMpl > 0 ? lcwbsMpl : '' }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox
                          v-model="pcll"
                          value="pcll"
                          style="pointer-events: none;"
                          class="form-custom-input-checkbox"
                        />
                      </b-td>
                      <b-td>
                        <span>Pink Crystal Liu Li</span>
                        <br>
                        <span>粉红晶琉璃罐</span>
                      </b-td>
                      <b-td>
                        URN0-PINK-CRST-LIULI
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ pcllNmg > 0 ? pcllNmg : '' }}
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ pcllMpl > 0 ? pcllMpl : '' }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox
                          v-model="byll"
                          value="byll"
                          style="pointer-events: none;"
                          class="form-custom-input-checkbox"
                        />
                      </b-td>
                      <b-td>
                        <span>Beeswax Yellow Liu Li</span>
                        <br>
                        <span>蜜蜡黄琉璃罐</span>
                      </b-td>
                      <b-td>
                        URN0-BEES-YELW-LIULI
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ byllNmg > 0 ? byllNmg : '' }}
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ byllMpl > 0 ? byllMpl : '' }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox
                          v-model="ro"
                          value="ro"
                          style="pointer-events: none;"
                          class="form-custom-input-checkbox"
                        />
                      </b-td>
                      <b-td>
                        <span>Red Onyx</span>
                        <br>
                        <span>写意人生（红玉罐</span>
                      </b-td>
                      <b-td>
                        URN0-ONYX-RED0-0212
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ roNmg > 0 ? roNmg : '' }}
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ roMpl > 0 ? roMpl : '' }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox
                          v-model="pj"
                          value="pj"
                          style="pointer-events: none;"
                          class="form-custom-input-checkbox"
                        />
                      </b-td>
                      <b-td>
                        <span>Poppy Jade</span>
                        <br>
                        <span>芙蓉西施玉（芙蓉玉罐</span>
                      </b-td>
                      <b-td>
                        URN0-JADE-POPY-1000
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ pjNmg > 0 ? pjNmg : '' }}
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ pjMpl > 0 ? pjMpl : '' }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox
                          v-model="rj"
                          value="rj"
                          style="pointer-events: none;"
                          class="form-custom-input-checkbox"
                        />
                      </b-td>
                      <b-td>
                        <span>Royalty Jade</span>
                        <br>
                        <span>皇家白玉</span>
                      </b-td>
                      <b-td>
                        URN0-RY-JADE_ORG
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ rjNmg > 0 ? rjNmg : '' }}
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ rjMpl > 0 ? rjMpl : '' }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox
                          v-model="others"
                          value="others"
                          style="pointer-events: none;"
                          class="form-custom-input-checkbox"
                        />
                      </b-td>
                      <b-td>
                        <span>Others</span>
                        <br>
                        <span>其他</span>
                      </b-td>
                      <b-td>
                        {{ othersName || '-' }}
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ othersNmg > 0 ? othersNmg : '' }}
                      </b-td>
                      <b-td
                        class="text-center value-filled"
                      >
                        {{ othersMpl > 0 ? othersMpl : '' }}
                      </b-td>
                    </b-tr> -->
                  </b-tbody>
                </b-table-simple>
              </div>
              <b-row class="mt-5 margin-top-1">
                <b-col md="6">
                  <p class="d-form-signature-title">Purchaser / Authorized Representative Signatory
                    <br>
                    <span>购买者/受委托领瓮人签名</span>
                  </p>
                  <div
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    class="form-signature-box signed"
                  >
                    <div class="form-signature-content">
                      <span
                        v-if="!isPurchaserSign"
                        class="form-signature-text"
                      />
                      <b-img
                        v-else
                        :src="purchaserSign"
                        alt="authorized-sign"
                      />
                    </div>
                  </div>
                  <div class="signature-date-block">
                    <p>Name 姓名: {{ customerName }}</p>
                    <p v-if="purchaserSignDate">
                      Date 日期: {{ dateFormatWithTime(purchaserSignDate) }}
                    </p>
                    <p v-else>
                      Date 日期:
                    </p>
                  </div>
                </b-col>
              </b-row>
              <div class="d-form-border mt-4 margin-top-1">
                <h5 class="d-form-office-use-title">
                  For office use 公务用栏
                </h5>
                <b-row>
                  <b-col
                    md="6"
                    class="pr-0"
                  >
                    <div class="padding-20">
                      <p class="d-form-signature-title">
                        Verified by 确认人员:</p>
                      <div
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        class="form-signature-box signed"
                      >
                        <div class="form-signature-content">
                          <span
                            v-if="!verifiedSign"
                            class="form-signature-text"
                          />
                          <b-img
                            v-else
                            :src="verifiedSignSrc"
                            alt="authorized-sign"
                          />
                        </div>
                      </div>
                      <div class="signature-date-block">
                        <p>Name 姓名: {{ verifiedSignName }}</p>
                        <p v-if="verifiedSignDate">
                          Date 日期: {{ dateFormatWithTime(verifiedSignDate) }}
                        </p>
                        <p v-else>
                          Date 日期:
                        </p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BImg, BTableSimple, BTbody, BTr, BTd,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import { required } from '@validations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BImg,
    // BFormCheckbox,
    BTableSimple,
    BTbody,
    BTr,
    BTd,
  },
  directives: {
    Ripple,
  },
  props: {
    digitalForm: {
      type: Object,
      required: true,
    },
    requestForm: {
      type: Object,
      required: true,
    },
    serviceRequest: {
      type: Object,
      required: true,
    },
    topSpacing: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoSrc: require('@/assets/images/logo/thian-leng-logo.svg'),
      isPurchaserSign: false,
      purchaserSign: '',
      purchaserSignDate: '',
      verifiedSign: false,
      verifiedSignSrc: '',
      verifiedSignDate: '',
      verifiedSignName: '',
      customerNameImageError: false,
      kinNameImageError: false,
      urnCollapse: false,
      purchaserCollapse: true,
      editFormInOtherStatus: false,
      tabActive: 'email',
      options: {
        penColor: '#000000',
        onBegin: () => { this.$refs.signaturePad.resizeCanvas() },
      },
      customerNameOptions: {
        penColor: '#000000',
        onBegin: () => { this.$refs.customerSignaturePad.resizeCanvas() },
      },
      kinNameOptions: {
        penColor: '#000000',
        onBegin: () => { this.$refs.kinSignaturePad.resizeCanvas() },
      },
      inventoryItems: [],
      splitQuantity: false,
      currentCustomerNameType: 'input',
      customerName: '',
      customerNameImage: '',
      customerNRIC: '',
      currentKinNameType: 'input',
      kinName: '',
      kinNameImage: '',
      kinNRIC: '',
      urnFileNo: '',
      relatedFileNo: '',
      fileNo: '',
      nicheLot: '',
      numberOfUnit: '',
      dgcwbs: '',
      dgcwbsMpl: 0,
      dgcwbsNmg: 0,
      lgcwbs: '',
      lgcwbsMpl: 0,
      lgcwbsNmg: 0,
      lcwbs: '',
      lcwbsMpl: 0,
      lcwbsNmg: 0,
      pcll: '',
      pcllMpl: 0,
      pcllNmg: 0,
      byll: '',
      byllMpl: 0,
      byllNmg: 0,
      ro: '',
      roMpl: 0,
      roNmg: 0,
      pj: '',
      pjMpl: 0,
      pjNmg: 0,
      rj: '',
      rjMpl: 0,
      rjNmg: 0,
      others: '',
      othersName: '',
      othersMpl: 0,
      othersNmg: 0,
      customerEmailVal: '',
      customerMobileVal: '',
      customerMessageValEmail: '',
      customerMessageValPhone: '',
      existingVerifiedSignSrcObject: {},
      existingPurchaserSignObject: {},
      editorOptionPhone: {
        modules: {
          toolbar: '#customer-sms-message',
        },
        placeholder: 'Type your message here',
      },
      editorOptionEmail: {
        modules: {
          toolbar: '#customer-email-message',
        },
        placeholder: 'Type your message here',
      },
      required,
    }
  },
  created() {
    this.makeFormValues()
  },
  methods: {
    makeFormValues() {
      this.fileNo = this.serviceRequest.fileNo
      const customerNameObject = this.serviceRequest.formValues.find(o => o.key === 'customerName')
      if (customerNameObject) {
        if (customerNameObject.value.startsWith('data:image/')) {
          this.customerNameImage = customerNameObject.value
          this.currentCustomerNameType = 'canvas'
        } else {
          this.currentCustomerNameType = 'input'
          this.customerName = customerNameObject.value
        }
      }
      this.customerNRIC = this.serviceRequest.formValues.find(o => o.key === 'customerNRIC')?.value
      const kinNameObject = this.serviceRequest.formValues.find(o => o.key === 'kinName')
      if (kinNameObject) {
        if (kinNameObject.value.startsWith('data:image/')) {
          this.kinNameImage = kinNameObject.value
          this.currentKinNameType = 'canvas'
        } else {
          this.currentKinNameType = 'input'
          this.kinName = kinNameObject.value
        }
      }
      this.kinNRIC = this.serviceRequest.formValues.find(o => o.key === 'kinNRIC')?.value
      if (this.requestForm.values.length) {
        const nicheLotObject = this.requestForm.values.find(o => o.key === 'nicheLot')
        if (nicheLotObject) {
          this.nicheLot = nicheLotObject.value
        }
        const numberOfUnitObject = this.requestForm.values.find(o => o.key === 'numberOfUnit')
        if (numberOfUnitObject) {
          this.numberOfUnit = numberOfUnitObject.value
        }
        const urnFileNoObject = this.requestForm.values.find(o => o.key === 'urnFileNo')
        if (urnFileNoObject) {
          this.urnFileNo = urnFileNoObject.value
        }
        const relatedFileNoObject = this.requestForm.values.find(o => o.key === 'relatedFileNo')
        if (relatedFileNoObject) {
          this.relatedFileNo = relatedFileNoObject.value
        }
        const inventoryItemsObject = this.requestForm.values.find(o => o.key === 'inventoryItems')
        if (inventoryItemsObject) {
          this.inventoryItems = inventoryItemsObject.value
        }

        const splitQuantityObj = this.requestForm.values.find(o => o.key === 'splitQuantity')
        if (splitQuantityObj) {
          this.splitQuantity = splitQuantityObj.value
        }
        // const dgcwbsObject = this.requestForm.values.find(o => o.key === 'dgcwbs')
        // if (dgcwbsObject) {
        //   this.dgcwbs = dgcwbsObject.value
        // }
        // const dgcwbsNmgObject = this.requestForm.values.find(o => o.key === 'dgcwbsNmg')
        // if (dgcwbsNmgObject) {
        //   this.dgcwbsNmg = dgcwbsNmgObject.value
        // }
        // const dgcwbsMplObject = this.requestForm.values.find(o => o.key === 'dgcwbsMpl')
        // if (dgcwbsMplObject) {
        //   this.dgcwbsMpl = dgcwbsMplObject.value
        // }
        // const lgcwbsObject = this.requestForm.values.find(o => o.key === 'lgcwbs')
        // if (lgcwbsObject) {
        //   this.lgcwbs = lgcwbsObject.value
        // }
        // const lgcwbsNmgObject = this.requestForm.values.find(o => o.key === 'lgcwbsNmg')
        // if (lgcwbsNmgObject) {
        //   this.lgcwbsNmg = lgcwbsNmgObject.value
        // }
        // const lgcwbsMplObject = this.requestForm.values.find(o => o.key === 'lgcwbsMpl')
        // if (lgcwbsMplObject) {
        //   this.lgcwbsMpl = lgcwbsMplObject.value
        // }
        // const lcwbsObject = this.requestForm.values.find(o => o.key === 'lcwbs')
        // if (lcwbsObject) {
        //   this.lcwbs = lcwbsObject.value
        // }
        // const lcwbsNmgObject = this.requestForm.values.find(o => o.key === 'lcwbsNmg')
        // if (lcwbsNmgObject) {
        //   this.lcwbsNmg = lcwbsNmgObject.value
        // }
        // const lcwbsMplObject = this.requestForm.values.find(o => o.key === 'lcwbsMpl')
        // if (lcwbsMplObject) {
        //   this.lcwbsMpl = lcwbsMplObject.value
        // }
        // const pcllObject = this.requestForm.values.find(o => o.key === 'pcll')
        // if (pcllObject) {
        //   this.pcll = pcllObject.value
        // }
        // const pcllNmgObject = this.requestForm.values.find(o => o.key === 'pcllNmg')
        // if (pcllNmgObject) {
        //   this.pcllNmg = pcllNmgObject.value
        // }
        // const pcllMplObject = this.requestForm.values.find(o => o.key === 'pcllMpl')
        // if (pcllMplObject) {
        //   this.pcllMpl = pcllMplObject.value
        // }
        // const byllObject = this.requestForm.values.find(o => o.key === 'byll')
        // if (byllObject) {
        //   this.byll = byllObject.value
        // }
        // const byllNmgObject = this.requestForm.values.find(o => o.key === 'byllNmg')
        // if (byllNmgObject) {
        //   this.byllNmg = byllNmgObject.value
        // }
        // const byllMplObject = this.requestForm.values.find(o => o.key === 'byllMpl')
        // if (byllMplObject) {
        //   this.byllMpl = byllMplObject.value
        // }
        // const roObject = this.requestForm.values.find(o => o.key === 'ro')
        // if (roObject) {
        //   this.ro = roObject.value
        // }
        // const roNmgObject = this.requestForm.values.find(o => o.key === 'roNmg')
        // if (roNmgObject) {
        //   this.roNmg = roNmgObject.value
        // }
        // const roMplObject = this.requestForm.values.find(o => o.key === 'roMpl')
        // if (roMplObject) {
        //   this.roMpl = roMplObject.value
        // }
        // const pjObject = this.requestForm.values.find(o => o.key === 'pj')
        // if (pjObject) {
        //   this.pj = pjObject.value
        // }
        // const pjNmgObject = this.requestForm.values.find(o => o.key === 'pjNmg')
        // if (pjNmgObject) {
        //   this.pjNmg = pjNmgObject.value
        // }
        // const pjMplObject = this.requestForm.values.find(o => o.key === 'pjMpl')
        // if (pjMplObject) {
        //   this.pjMpl = pjMplObject.value
        // }
        // const rjObject = this.requestForm.values.find(o => o.key === 'rj')
        // if (rjObject) {
        //   this.rj = rjObject.value
        // }
        // const rjNmgObject = this.requestForm.values.find(o => o.key === 'rjNmg')
        // if (rjNmgObject) {
        //   this.rjNmg = rjNmgObject.value
        // }
        // const rjMplObject = this.requestForm.values.find(o => o.key === 'rjMpl')
        // if (rjMplObject) {
        //   this.rjMpl = rjMplObject.value
        // }
        // const othersObject = this.requestForm.values.find(o => o.key === 'others')
        // if (othersObject) {
        //   this.others = othersObject.value
        // }
        // const othersNameObject = this.requestForm.values.find(o => o.key === 'othersName')
        // if (othersNameObject) {
        //   this.othersName = othersNameObject.value
        // }
        // const othersNmgObject = this.requestForm.values.find(o => o.key === 'othersNmg')
        // if (othersNmgObject) {
        //   this.othersNmg = othersNmgObject.value
        // }
        // const othersMplObject = this.requestForm.values.find(o => o.key === 'othersMpl')
        // if (othersMplObject) {
        //   this.othersMpl = othersMplObject.value
        // }
        const purchaserSignObject = this.requestForm.values.find(o => o.key === 'purchaserSign')
        if (purchaserSignObject) {
          this.existingPurchaserSignObject = purchaserSignObject
          this.purchaserSign = purchaserSignObject.value
          this.isPurchaserSign = true
          this.purchaserSignDate = purchaserSignObject.date
        }
        const verifiedSignSrcObject = this.requestForm.values.find(o => o.key === 'verifiedSignSrc')
        if (verifiedSignSrcObject) {
          this.existingVerifiedSignSrcObject = verifiedSignSrcObject
          this.verifiedSignSrc = verifiedSignSrcObject.value
          this.verifiedSign = true
          this.verifiedSignDate = verifiedSignSrcObject.date
          this.verifiedSignName = verifiedSignSrcObject.name
        }
      }
    },
  },
}
</script>
<style scoped>
@media print {
  .urn-form-wrapper{
     margin-top: 1rem !important;
  }
  input[type=checkbox], input[type=radio] {
      opacity: 1 !important;
  }
   .margin-bottom-0{
       margin-bottom: 0 !important;
  }
  .margin-top-0{
       margin-top: 0 !important;
  }
  .margin-top-1{
       margin-top: 1rem !important;
  }
  .margin-top-bottom-0{
       margin-top: 0 !important;
       margin-bottom: 0 !important;
  }
}
</style>
